(function(){
  let windowLocation = window.location.search;
  let $hiddenInput = $('.input-hidden');


  if($hiddenInput) {
    windowLocation = windowLocation.replace(/%20/g, ' ');
    $hiddenInput.val(windowLocation);
  }
})();